import { z } from 'zod';

const annotationCountSchema = z.object({
  type: z.string(),
  count: z.number().nonnegative(),
});

export const statisticsSchema = z.object({
  elementAnnotations: z.array(annotationCountSchema),
  publications: z.number().nonnegative(),
  reactionAnnotations: z.array(annotationCountSchema),
});
